import type { ReactNode } from "react";
import { Button, type ButtonVariant, useT } from "@mmm/ui";
interface DialogActionsProps {
  cancelLabel?: string;
  confirmLabel: ReactNode;
  confirmVariant?: ButtonVariant;
  confirmDisabled?: boolean;
  confirmType?: "button" | "submit";
  submitting?: boolean;
  onCancel: () => void;
  onConfirm?: () => void;
}

export function DialogActions({
  cancelLabel,
  confirmLabel,
  confirmVariant = "primary",
  confirmDisabled = false,
  confirmType = "submit",
  submitting = false,
  onCancel,
  onConfirm,
}: DialogActionsProps) {
  const t = useT();
  return (
    <div className="mmm-modal-actions">
      <Button variant="secondary" onClick={onCancel} disabled={submitting}>
        {cancelLabel ?? t("common.cancel")}
      </Button>
      <Button type={confirmType} variant={confirmVariant} disabled={confirmDisabled || submitting} onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </div>
  );
}
